export default "__VITE_ASSET__50594b5c__"